import { CwanUxProvider } from 'cwan-ux-core-react'
import { createRoot } from 'react-dom/client'
import './index.scss'
import { BrowserRouter } from 'react-router-dom'
import { App } from './components/app'
import { environment } from './environment.ts'
import { loadSidenavAndLogin } from './lib/sidenav/sidenav.service.ts'
import { setupMsw } from './mocks/setup-msw.ts'

function renderApp(skipSidenavAuth: boolean) {
  const rootEl = document.getElementById('app')
  if (!rootEl) throw new Error('Cannot find app root')

  const authComplete =
    skipSidenavAuth || (window.sidenav?.isAuthenticationComplete ?? false)

  const root = createRoot(rootEl)
  root.render(
    authComplete && (
      <CwanUxProvider enableAgGrid authComplete={authComplete}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </CwanUxProvider>
    )
  )
}

console.log(
  `running in realm: ${environment.realm}, sidenav: ${environment.sidenavBaseUrl}`
)

if (environment.test) {
  // Setup MSW and then render the app
  setupMsw()
    .then(() => renderApp(true))
    .catch(() => renderApp(true)) // Render app even if MSW setup fails
} else {
  loadSidenavAndLogin()
    .then(() => {
      renderApp(false)
    })
    .catch((error) => {
      //TODO: go to error page
      console.error(`sidenav login failed: ${error}`)
    })
}
